import { useState } from "react";
import { Play, X } from "lucide-react";
import { BRAND } from "../data/mock";

// Placeholder video — user can replace with their actual demo URL later
const DEMO_VIDEO_ID = ""; // Set to YouTube video ID once the user provides their demo URL

export const VideoDemo = () => {
  const [open, setOpen] = useState(false);

  return (
    <section
      id="video"
      data-testid="video-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-teal-50/40 to-white" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-teal-600">
            See it in action
          </span>
          <h2
            data-testid="video-headline"
            className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
          >
            Watch how easy your <span className="text-orange-500">hisab</span> can be.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            A 2-minute walkthrough of invoicing, WhatsApp reminders, inventory and
            end-of-day cash check — straight from the Reptile Hisabbook app.
          </p>
        </div>

        {/* Video thumbnail card */}
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="video-play-btn"
          className="group relative w-full block rounded-[2rem] overflow-hidden border border-slate-200 shadow-2xl shadow-slate-300/40 hover:shadow-3xl transition-all"
        >
          <div className="relative aspect-video bg-slate-900">
            <img
              src={BRAND.heroImageUrl}
              alt="Reptile Hisabbook demo"
              className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-slate-900/30 to-transparent" />

            {/* Play button */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-orange-500 blur-2xl opacity-50 group-hover:opacity-80 transition-opacity" />
                <div className="relative h-20 w-20 md:h-24 md:w-24 rounded-full bg-orange-500 text-white flex items-center justify-center shadow-2xl shadow-orange-500/40 group-hover:scale-110 transition-transform">
                  <Play className="h-8 w-8 md:h-10 md:w-10 fill-white ml-1" />
                </div>
              </div>
            </div>

            {/* Caption strip */}
            <div className="absolute bottom-0 inset-x-0 p-5 md:p-7 text-left">
              <div className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur-md px-3 py-1 ring-1 ring-white/20">
                <span className="h-2 w-2 rounded-full bg-orange-400 animate-pulse" />
                <span className="text-xs uppercase tracking-[0.18em] font-semibold text-white">
                  Product demo · 2:14
                </span>
              </div>
              <div className="mt-2 font-heading text-white text-lg md:text-2xl font-semibold">
                Reptile Hisabbook — Quick walkthrough
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Lightbox modal */}
      {open && (
        <div
          data-testid="video-modal"
          className="fixed inset-0 z-[60] bg-slate-950/85 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative w-full max-w-5xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="video-modal-close"
              className="absolute -top-12 right-0 h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
              onClick={() => setOpen(false)}
              aria-label="Close video"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="aspect-video rounded-2xl overflow-hidden bg-black shadow-2xl">
              {DEMO_VIDEO_ID ? (
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${DEMO_VIDEO_ID}?autoplay=1&rel=0`}
                  title="Reptile Hisabbook demo"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              ) : (
                <div className="w-full h-full flex flex-col items-center justify-center text-center px-6 text-white">
                  <div className="h-16 w-16 rounded-full bg-orange-500/20 text-orange-400 flex items-center justify-center mb-4">
                    <Play className="h-7 w-7" />
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl font-bold">
                    Demo video coming soon
                  </h3>
                  <p className="mt-2 text-sm text-slate-300 max-w-md">
                    Our product walkthrough is being polished. In the meantime,
                    explore the features below or get in touch for a live demo.
                  </p>
                  <a
                    href="#contact"
                    onClick={() => setOpen(false)}
                    className="mt-5 inline-flex items-center gap-2 rounded-full bg-orange-500 hover:bg-orange-600 px-5 py-2.5 text-sm font-semibold transition-colors"
                  >
                    Request a live demo
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoDemo;
